export const WalletName = {
  PHANTOM: 'phantom',
  METAMASK: 'metamask',
  XAMAN: 'xaman',
};

export const WalletNameDisplay = {
  [WalletName.PHANTOM]: 'Phantom',
  [WalletName.METAMASK]: 'Metamask',
  [WalletName.XAMAN]: 'Xaman',
};

export const callbackWalletStatus = {
  SUCCESS: 'successed',
  FAIL: 'failured',
};
